import React from 'react';
import { Box } from '@mui/material';
import { getMediaPath } from 'app/functions';
import { spacing } from 'common/theme';
import CloseIcon from 'assets/icons/x-close-black-icon.svg';

export const PopupCloseButton = ({ onClose, iconSize = 12, testID }) => (
    <Box
        component="button"
        type="button"
        onClick={onClose}
        aria-label="סגור"
        testId={testID}
        sx={{
            position: 'absolute',
            top: { xs: `${spacing.xs}px`, sm: `${spacing.sm}px` },
            right: { xs: `${spacing.xs}px`, sm: `${spacing.sm}px` },
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: `${spacing.xs / 2}px`,
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            opacity: 0.4,
            lineHeight: 0,
            '&:hover': {
                opacity: 0.65,
            },
        }}
    >
        <Box
            component="img"
            src={getMediaPath(CloseIcon)}
            alt=""
            sx={{ width: iconSize, height: iconSize, display: 'block' }}
        />
    </Box>
);
